export const statusColor = {
  available: '#0AB33E',
  busy: '#FF0600',
  away: '#5B5B5B',
}

export const userStatus = [
  {
    id: 1,
    title: 'Available',
    translationKey: 'status.available',
    subTitle: 'Based on activity',
    subTranslationKey: 'status.availableSub',
    color: statusColor.available,
  },
  {
    id: 2,
    title: 'Busy',
    translationKey: 'status.busy',
    subTitle: 'Mute chat notifications',
    subTranslationKey: 'status.busySub',
    color: statusColor.busy,
  },
  {
    id: 3,
    title: 'Away',
    translationKey: 'status.away',
    color: statusColor.away,
  },
];

export const userStatusMsg = [
  {
    id:1,
    title: 'In a meeting',
    translationKey: 'status.inAMeeting',
    key:'in_a_meeting',
    icon: '/images/meetingStatusIcon.svg',
    presence:'busy'
  },
  {
    id:2,
    title: 'Traveling',
    translationKey: 'status.traveling',
    key:'traveling',
    icon: '/images/travellingStatusIcon.svg',
    presence:'offline'
  },
  {
    id:3,
    title: 'Out of office',
    translationKey: 'status.outOfOffice',
    key:'out_of_office',
    icon: '/images/oofficeStatusIcon.svg',
    presence:'offline'
  },
  {
    id:4,
    title: 'Out sick',
    translationKey: 'status.outSick',
    key:'out_sick',
    icon: '/images/outSickStatusIcon.svg',
    presence:'offline'
  },
  {
    id:5,
    title: 'Working remotely',
    translationKey: 'status.workingRemotely',
    key:'working_remotely',
    icon: '/images/remoteStatusIcon.svg',
    presence:'busy'
  },
  {
    id:6,
    title: 'Vacationing',
    translationKey: 'status.vacationing',
    key:'Vacationing',
    icon: '/images/vacationStatusIcon.svg',
    presence:'offline'
  },
]


export const myBridgeData = [
  {
    heading: "If you want excuses, small talks, and gossip, stick to TikTok, Facebook, and LinkedIn.",
    description: "For meaningful connections, professional growth, and career advancement, join myBridge.me. No BS, just real opportunities.",
    headingKey: 'staticData.heading1',
    descriptionKey: 'staticData.description1',
  },
  {
    heading: "LinkedIn/myBridge – Concerned about managing multiple online profiles? Problem solved!",
    description: "myBridge’s extension keeps your LinkedIn and myBridge profiles updated by syncing information across both apps seamlessly.",
    headingKey: 'staticData.heading2',
    descriptionKey: 'staticData.description2',
  },
  {
    heading: "myBridge.me integrates networking with productivity tools for seamless collaboration, scheduling, and connections",
    description: "Perfect for remote work, project management, and building a strong professional network.",
    headingKey: 'staticData.heading3',
    descriptionKey: 'staticData.description3',
  },
  {
    heading: "myBridge combines social networking with productivity in one seamless platform.",
    description: "Grow your network, collaborate, and manage appointments—stay engaged, efficient, and connected without distractions. It’s productivity and networking redefined.",
    headingKey: 'staticData.heading4',
    descriptionKey: 'staticData.description4',
  },
  {
    heading: "Who says productivity and social networking can’t coexist?",
    description: "myBridge unites collaboration, networking, and productivity tools, enabling you to connect, manage projects, and stay focused—all in one streamlined platform.",
    headingKey: 'staticData.heading5',
    descriptionKey: 'staticData.description5',
  },
  {
    heading: "myBridge: Productivity and social networking—no compromises.",
    description: "Seamlessly connect, collaborate, and stay efficient with a platform that integrates professional networking and productivity tools, helping you manage time, projects, and connections all in one place.",
    headingKey: 'staticData.heading6',
    descriptionKey: 'staticData.description6',
  },
  {
    heading: "Professional Networking 2.0",
    description: "myBridge combines professional networking with productivity in one seamless platform. Grow your network, collaborate, and manage appointments—stay engaged, efficient, and connected without distractions. It’s networking and productivity redefined.",
    headingKey: 'staticData.heading7',
    descriptionKey: 'staticData.description7',
  },
  {
    heading: "Why myBridge.me is necessary",
    description: "LinkedIn isn't enough for today's professional networking. Combine the strengths of myBridge.me and LinkedIn for an unbeatable networking experience.",
    headingKey: 'staticData.heading8',
    descriptionKey: 'staticData.description8',
  },
  {
    heading: "myBridge.me: the all-in-one social media app for professionals",
    description: "Networking, file sharing, calendar scheduling, meetings, calls, and job search – everything you need in one place. Join now!",
    headingKey: 'staticData.heading9',
    descriptionKey: 'staticData.description9',
  },
  {
    heading: "Attention small businesses, employers, and hiring managers!",
    description: "myBridge.me offers a promo: free job posts, candidate screening, and delivery of ideal candidates. Try myBridge.me now!",
    headingKey: 'staticData.heading10',
    descriptionKey: 'staticData.description10',
  },
  {
    heading: "Targeting small businesses, employers, and hiring managers",
    description: "myBridge.me promo offers free job posts, and screens, and delivers ideal candidates. Let myBridge handle hiring and deliver top talent to you.",
    headingKey: 'staticData.heading11',
    descriptionKey: 'staticData.description11',
  },
  {
    heading: "Using LinkedIn for networking?",
    description: "Don’t miss myBridge.me, a complementary tool with features LinkedIn lacks: myDisk, myTeam, myCalendar. Perfect for serious professionals. Enhance your LinkedIn experience today!",
    headingKey: 'staticData.heading12',
    descriptionKey: 'staticData.description12',
  },
  {
    heading: "Professional networking 2.0, myBridge.me is LinkedIn on steroids.",
    description: "Built just for you with features like myDisk, myTeam, and myCalendar that LinkedIn lacks. Join now!",
    headingKey: 'staticData.heading13',
    descriptionKey: 'staticData.description13',
  },
  {
    heading: "myBridge.me – LinkedIn on steroids!",
    description: "Built just for you, myBridge.me offers powerful features like myDisk, myTeam, and myCalendar that LinkedIn lacks. Join now and take your professional network to the next level!",
    headingKey: 'staticData.heading14',
    descriptionKey: 'staticData.description14',
  },
  {
    heading: "myBridge.me: The networking app to watch",
    description: "Rivaling LinkedIn with features like myDisk, myTeam, and myCalendar. Perfect for networking, file storage, career growth, and free job posts for small businesses.",
    headingKey: 'staticData.heading15',
    descriptionKey: 'staticData.description15',
  },
  {
    heading: "Attention Working Professionals!",
    description: "Explore myBridge.me, the social platform built for your career. Enjoy unique features like networking, file sharing, scheduling, meetings, calls, and job search—beyond LinkedIn.",
    headingKey: 'staticData.heading16',
    descriptionKey: 'staticData.description16',
  },
  {
    heading: "Attention Small Businesses, Employers, and Hiring Managers!",
    description: "Try myBridge.me, your all-in-one hiring solution. Enjoy free job posts and candidate screening, plus tools for networking, file sharing, and scheduling. Simplify recruitment and find top talent—join today!",
    headingKey: 'staticData.heading17',
    descriptionKey: 'staticData.description17',
  },
  {
    heading: "myBridge.me: The Perfect Complement to LinkedIn.",
    description: "Boost your professional networking with myBridge.me's unique features. Store and access files securely with myDisk, collaborate easily with myTeam’s workspace tools, and manage events with myCalendar. It’s the all-in-one platform for career growth.",
    headingKey: 'staticData.heading18',
    descriptionKey: 'staticData.description18',
  },
  {
    heading: "myBridge.me—the perfect complement to LinkedIn, not a rival!",
    description: "myBridge.me enhances your experience with features like myDisk for secure file access, myTeam for seamless collaboration, and myCalendar for organized scheduling. Streamline your workflow and boost your career today!",
    headingKey: 'staticData.heading19',
    descriptionKey: 'staticData.description19',
  },
  {
    heading: "The Networking App to Watch Out For!",
    description: "myBridge.me is transforming professional networking with tools like myDisk for secure file access, myTeam for seamless collaboration, and myCalendar for effortless scheduling. Complement your career growth with myBridge.me—your all-in-one networking solution.",
    headingKey: 'staticData.heading20',
    descriptionKey: 'staticData.description20',
  },
  {
    heading: "A Top Choice for Secure Data Storage!",
    description: "For unmatched security and convenience, myBridge.me’s myDisk ranks among the top 5 cloud storage solutions. It offers secure file sharing, business-ready storage, and easy access—ideal for all your data needs. Join myBridge.me for reliable storage today!",
    headingKey: 'staticData.heading21',
    descriptionKey: 'staticData.description21',
  },
  {
    heading: "Your All-In-One Professional Social Media Platform!",
    description: "myBridge.me is the ultimate solution for career management. Connect with industry leaders, securely share documents with myDisk, organize with myCalendar, conduct virtual meetings, and find job opportunities—all in one seamless platform. Simplify your professional life today!",
    headingKey: 'staticData.heading22',
    descriptionKey: 'staticData.description22',
  },
  {
    heading: "Attention Small Businesses, Employers, and Hiring Managers!",
    description: "Discover myBridge.me—the ultimate hiring tool! Take advantage of our promotion: Free job posts, plus candidate screening, networking, file sharing, scheduling, and calls. Simplify recruitment and find the perfect fit—sign up today!",
    headingKey: 'staticData.heading23',
    descriptionKey: 'staticData.description23',
  },
  {
    heading: "myBridge.me: The Perfect Complement to LinkedIn",
    description: "In today’s professional world, LinkedIn isn’t enough—myBridge.me enhances it. With features like networking for deeper engagement, secure file sharing, scheduling, virtual meetings, and job searching, myBridge.me fills the gaps LinkedIn can’t, offering a comprehensive professional networking solution.",
    headingKey: 'staticData.heading24',
    descriptionKey: 'staticData.description24',
  },
  {
    heading: "Professionals on myBridge.me mean business!",
    description: "If you're not tired of excuses, small talk, and gossip, stick to TikTok, Facebook, or LinkedIn. But if you're serious about meaningful connections, professional growth, and career advancement, myBridge.me is the platform for you. Join today to connect with like-minded professionals focused on real opportunities and success.",
    headingKey: 'staticData.heading25',
    descriptionKey: 'staticData.description25',
  },
  {
    heading: "Leave the Small Talk and Gossip Behind",
    description: "Serious professionals choose myBridge.me for meaningful connections and growth. Skip Facebook and LinkedIn distractions. Join today to elevate your networking with tools built for success. Experience the difference with myBridge.me!",
    headingKey: 'staticData.heading26',
    descriptionKey: 'staticData.description26',
  },
  {
    heading: "Employers and Hiring Managers!",
    description: "myBridge.me is your ultimate hiring solution. Post jobs for free and simplify your recruitment process with seamless tools for networking, file sharing, and scheduling.",
    headingKey: 'staticData.heading27',
    descriptionKey: 'staticData.description27',
  },
  {
    heading: "myEvent: Host Events and Webinars Effortlessly",
    description: "Introducing myEvent from myBridge.me! Plan and execute flawless events with seamless team collaboration, secure file sharing, virtual meetings, and instant messaging. Elevate your event planning today with myEvent!",
    headingKey: 'staticData.heading28',
    descriptionKey: 'staticData.description28',
  },
  {
    heading: "myTeam: Organize as a Community or Team",
    description: "Powered by myBridge.me, myTeam is the ultimate collaboration tool. Enjoy seamless teamwork, secure file sharing with unlimited storage, effective virtual meetings, and instant communication. Simplify workflows, boost productivity, and enhance team efficiency with myTeam.",
    headingKey: 'staticData.heading29',
    descriptionKey: 'staticData.description29',
  },
  {
    heading: "myDisk - A Top Choice for Secure Data Storage",
    description: "Powered by myBridge.me, myDisk offers unparalleled secure cloud document storage, ranked among the top 5 disk websites. Enjoy effortless file sharing and management with guaranteed safety and accessibility. Trust myBridge.me and myDisk for reliable, efficient storage solutions.",
    headingKey: 'staticData.heading30',
    descriptionKey: 'staticData.description30',
  },
  {
    heading: "Not a rival, but a complement",
    description: "myBridge.me offers features LinkedIn lacks: myDisk, myTeam, and myCalendar. This is professional networking 2.0, combining social networking with productivity in one seamless platform.",
    headingKey: 'staticData.heading31',
    descriptionKey: 'staticData.description31',
  },
  {
    heading: "Enhance your LinkedIn experience today with myBridge.me!",
    description: "A complementary tool for serious professionals, offering features LinkedIn lacks: myDisk, myTeam, and myCalendar. Take your networking to the next level! Professional networking redefined.",
    headingKey: 'staticData.heading32',
    descriptionKey: 'staticData.description32',
  },
  {
    heading: "myEvent Powered by myBridge.me",
    description: "myEvent lets you host free events and webinars for any audience size. It integrates with popular teleconference platforms, providing seamless access to your preferred location for smooth and efficient event execution.",
    headingKey: 'staticData.heading33',
    descriptionKey: 'staticData.description33',
  },
  {
    heading: "myCalendar Powered by myBridge.me",
    description: "myCalendar integrates seamlessly with most calendars, allowing you to choose where to add events, check for conflicts, and avoid double booking. It also integrates with popular teleconference platforms, ensuring easy access to your preferred location for smooth, efficient meetings.",
    headingKey: 'staticData.heading34',
    descriptionKey: 'staticData.description34',
  },
  {
    heading: "myBridge.me's appointment scheduler is ranked in the top 5 and is completely free!",
    description: "It integrates with popular teleconference platforms, ensuring seamless access to your preferred location for each appointment. Let your network and customers easily schedule virtual and in-person appointments with you using myBridge.me’s scheduler.",
    headingKey: 'staticData.heading35',
    descriptionKey: 'staticData.description35',
  },
  {
    heading: "LinkedIn is excellent for networking and showcasing your professional profile, but what about productivity?",
    description: "That’s where myBridge.me steps in. We go beyond connecting professionals to empower them with tools that streamline daily tasks. From Disk for secure file storage to meeting and event management, call scheduling, and calendar sync, myBridge integrates seamlessly into your professional life. It’s not just about connections—it’s about working smarter, staying organized, and achieving more. Productivity is the foundation of success, and we’re here to help you build it.",
    headingKey: 'staticData.heading36',
    descriptionKey: 'staticData.description36',
  },
  {
    heading: "LinkedIn excels at professional networking, but what about productivity?",
    description: "That’s where myBridge shines. With features like secure file storage, meeting and event management, call scheduling, and calendar sync, myBridge helps professionals streamline their work. It’s your all-in-one tool to stay organized, work smarter, and achieve more every day.",
    headingKey: 'staticData.heading37',
    descriptionKey: 'staticData.description37',
  },
  {
    heading: "The internet has its positive sides, and myBridge.me is here to highlight them.",
    description: "Say goodbye to constant distracting notifications and click-bait traps from platforms like Facebook, LinkedIn, and TikTok. With myBridge.me, embrace a productivity-focused digital experience that empowers you to work smarter, stay organized, and achieve your goals seamlessly.",
    headingKey: 'staticData.heading38',
    descriptionKey: 'staticData.description38',
  },
  {
    heading: "100% free. That’s great, isn’t it?",
    description: "With myBridge.me, you enjoy genuine networking with like-minded professionals, combined with powerful productivity tools like appointment scheduling, file storage, meetings, and calls. Stay productive and focused while building meaningful connections!",
    headingKey: 'staticData.heading39',
    descriptionKey: 'staticData.description39',
  },
  {
    heading: "We all need a mentor at some point—a shoulder to climb on.",
    description: "Whether you’re open to mentoring eager minds or seeking guidance as a mentee, myBridge.me makes it effortless. With our status badges, you can attract the right connections and create opportunities for meaningful professional growth.",
    headingKey: 'staticData.heading40',
    descriptionKey: 'staticData.description40',
  },
  {
    heading: "It’s David vs. Goliath—big doesn’t always mean better.",
    description: "myBridge.me vs. LinkedIn: while LinkedIn is great for networking and showcasing your professional profile, myBridge.me goes far beyond. Designed for the ideal professional, it combines networking and profile-building with powerful productivity tools like appointment scheduling, file storage, meeting management, and more.",
    headingKey: 'staticData.heading41',
    descriptionKey: 'staticData.description41',
  },
  {
    heading: "Need to show off a different side?",
    description: "myBridge.me lets you create multiple pages with one sign-on to showcase your creativity and attract diverse audiences. Whether it’s personal, professional, or creative, myBridge.me empowers you to share it all. With us, there’s no limit to what you can achieve!",
    headingKey: 'staticData.heading42',
    descriptionKey: 'staticData.description42',
  },
  {
    heading: "What’s going on?",
    description: "Whether you’re celebrating a career promotion, attending an event, hiring, or open to work, myBridge.me status badges help you communicate the right message to your network effortlessly. Stay connected and share your updates with the people who matter most, all in one place.",
    headingKey: 'staticData.heading43',
    descriptionKey: 'staticData.description43',
  },
  {
    heading: "LinkedIn, Facebook, Twitter, and TikTok combined—myBridge.me brings you the best of all worlds without the distractions and noise.",
    description: "Organize your content, showcase pictures and videos with top-notch quality, and enhance your profile and networking with advanced features. Coupled with our Gen AI to help with personalized insights and optimization, myBridge has everything professionals need to win.",
    headingKey: 'staticData.heading44',
    descriptionKey: 'staticData.description44',
  },
  {
    heading: "Some would rather whine and gripe, but not the professionals on myBridge.me",
    description: "We are doers. We focus on results, building meaningful connections, and leveraging powerful tools to get things done. If you’re ready to make an impact, myBridge.me is where you belong.",
    headingKey: 'staticData.heading45',
    descriptionKey: 'staticData.description45',
  },
  {
    heading: "You either do it or you don’t—there’s no 'maybe.'",
    description: "With the productivity tools on myBridge.me, there’s no excuse for not performing. From scheduling and file management to networking and collaboration, everything you need to succeed is right at your fingertips. Make it happen.",
    headingKey: 'staticData.heading46',
    descriptionKey: 'staticData.description46',
  },
  {
    heading: "This shouldn’t be about money—LinkedIn charges for everything, even for profile views and networking.",
    description: "Where’s the genuine service and care for professionals? With myBridge.me, it’s 100% free. All the tools and services you need to network, collaborate, and stay productive are accessible without a price tag. Because professionals deserve better.",
    headingKey: 'staticData.heading47',
    descriptionKey: 'staticData.description47',
  },
  {
    heading: "Professionals deserve better.",
    description: "The idea behind myBridge is to bridge the gaps LinkedIn leaves behind. LinkedIn assumes networking and showcasing a professional profile is all professionals need. But what about productivity and targeted tools to get real work done? myBridge combines networking with powerful tools like scheduling, file storage, meeting management, and more—all designed to help professionals excel.",
    headingKey: 'staticData.heading48',
    descriptionKey: 'staticData.description48',
  },
  {
    heading: "Life is happening—embrace it.",
    description: "Why pay for costly productivity tools when you can have them all for free on a single platform? Virtual meetings with your team, secure disk storage, appointment scheduling, calendar sync, and more—all available at myBridge.me. Because productivity should empower, not cost.",
    headingKey: 'staticData.heading49',
    descriptionKey: 'staticData.description49',
  },
  {
    heading: "Productivity should empower, not cost.",
    description: "Think about it—professionals want to stay productive, not get distracted by the constant barrage of internet noise. The cost of sticking to traditional social media like LinkedIn is too high, from clickbait traps to endless notifications. That’s why we created myBridge.me, with a singular focus on productivity. Here, professionals can work smarter, connect meaningfully, and achieve more—without distractions.",
    headingKey: 'staticData.heading50',
    descriptionKey: 'staticData.description50',
  },
  {
    heading: "It’s now a level playing field—the tools are in everyone’s hands.",
    description: "With the full suite of productivity tools seamlessly integrated into an online social networking platform, myBridge.me has redefined what it means to connect and work. The stage is set, the cast is ready—your move.",
    headingKey: 'staticData.heading51',
    descriptionKey: 'staticData.description51',
  },
  {
    heading: "One-Cent Solution to Hiring",
    description: "At myBridge.me, we help business owners eliminate hiring costs by offering automated screening, access to qualified candidates, and productivity tools—leading to significant cost savings. Our approach simplifies the recruiting process from start to finish.",
    headingKey: 'staticData.heading52',
    descriptionKey: 'staticData.description52',
  },
  {
    heading: "One, Two... Next.",
    description: "A professional at a time. We’re on a mission to empower the world by putting productivity tools in everyone’s hands. myBridge.me is here to revolutionize how we work—blending productivity with networking to unlock new opportunities for success.",
    headingKey: 'staticData.heading53',
    descriptionKey: 'staticData.description53',
  }
];
